import { render, staticRenderFns } from "./zhiyexiangqing_mobile.vue?vue&type=template&id=52dc0b20&scoped=true"
import script from "./zhiyexiangqing_mobile.vue?vue&type=script&lang=js"
export * from "./zhiyexiangqing_mobile.vue?vue&type=script&lang=js"
import style0 from "./zhiyexiangqing_mobile.vue?vue&type=style&index=0&id=52dc0b20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc0b20",
  null
  
)

export default component.exports